import styled, { css } from 'styled-components'
import { colors, helpers } from 'client/styles'
import { PriceDetailsBase } from 'client/components/PriceDetails/styles'
import { AdditionalFeesBase } from 'src/comps/AdditionalFees/styles'

function getTheme(theme) {
  if (theme === 'light') {
    return css`
      background-color: ${colors.white};
      border: 2px solid ${colors.grey4};
      border-radius: 8px;
    `
  }

  return css`
    color: ${colors.white};
    background-color: ${colors.grey0};
    border: 2px solid ${colors.grey0};
    border-radius: 5px;
    padding-block: 10px;
    padding-inline: 10px;

    /* Arrow */
    &:after {
      content: '';
      width: 0;
      height: 0;
      border-inline-start: 6px solid transparent;
      border-inline-end: 6px solid transparent;
      border-block-start: 6px solid ${colors.grey1};
      inset-block-end: -5px;
      position: absolute;
      ${props => props.position === 'right' && `inset-inline-start: 90%;`};
      ${props => props.position === 'left' && `inset-inline-start: 10%;`};
      ${props => props.position === 'center' && `inset-inline-start: 50%;`};
      transform: translateX(calc(var(--transform-direction) * -50%));
    }

    p {
      color: ${colors.white};
      font-size: 12px;
      line-height: 1.4;
    }
  `
}

export const TooltipBase = styled.div`
  display: inline-block;
  position: relative;
  fill: ${colors.grey2};

  ${PriceDetailsBase} {
    border-radius: 8px;
  }

  ${PriceDetailsBase}, ${AdditionalFeesBase} {
    margin-block-end: 0 !important;
  }
`

const bubbleStyles = css`
  position: absolute;
  inset-block-start: -6px;
  inset-inline-start: 50%;
  ${props =>
    props.position === 'right' &&
    `transform: translate(calc(var(--transform-direction) * -90%), -100%)`};
  ${props =>
    props.position === 'left' &&
    `transform: translate(calc(var(--transform-direction) * -10%), -100%)`};
  ${props =>
    props.position === 'center' &&
    `transform: translate(calc(var(--transform-direction) * -50%), -100%)`};
  ${props => getTheme(props.theme)};
  width: ${props => `${props.width}px`};
  z-index: 20;
  cursor: default;
`

export const TooltipBubble = styled.div`
  ${props => (props.isOpen ? bubbleStyles : helpers.isVisuallyHidden)};
`

export const Trigger = styled.button`
  padding-block: 0;
  padding-inline: 0;
  appearance: none;
  border: none;
  background-color: transparent;
  cursor: pointer;
`

export const Overlay = styled.div`
  display: ${props => (props.visible ? 'block' : 'none')};
  position: fixed;
  inset-block-start: 0;
  inset-inline-start: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
`
